export const EquipmentScheduleEntryType: {
    AVAILABLE: 'AVAILABLE',
    BLOCKED: 'BLOCKED',
} = {
    AVAILABLE: 'AVAILABLE',
    BLOCKED: 'BLOCKED',
};

export type EquipmentScheduleEntryType = (typeof EquipmentScheduleEntryType)[keyof typeof EquipmentScheduleEntryType]